import os from 'os';

//
// Read file
//
// eslint-disable-next-line no-unused-vars
function readFS (filename) {
    try {
        const reader = new FileReader();
        reader.onload = (e) => {
            const fileContents = e.target.result;
            // eslint-disable-next-line no-console
            console.log(fileContents);
        };
        reader.readAsText(filename);
        return reader.readAsText(filename) || '';
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error: ', error);
        return '';
    }
}

//
// Write file
//
function writeFS (filename, data) {
    try {
        const filepath = `${os.tmpdir()}/${filename}`;
        const downloadLink = document.createElement('a');

        downloadLink.href = `data:application/txt,${data}`;
        downloadLink.download = filename;
        downloadLink.click();
        // eslint-disable-next-line no-console
        console.log(`Data saved to ${filepath}`);
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error: ', error);
    }
}

//
// Update file
//
export function updateFile (filename, data) {
    try {
        // const currenData = readFS(filename);
        // if (currenData.length) {
        //     writeFS(filename, `${currenData}${data}`);
        // }
        writeFS(filename, `${data}`);
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error: ', error);
    }
}
